import { useState } from 'react';

import { CameraOutlined } from '@ant-design/icons';
import { Button, Col, Space, Typography } from 'antd';
import { Avatar } from 'components';
import { BASE_URL, USER_AVATAR_FOLDER } from 'config';
import { User } from 'models/user';

import UploadAvatarModal from '../upload-avatar';

const { Title } = Typography;

interface HeadSectionProps {
  userData: User;
  isAvatarChangeAllowed: boolean;
}

const HeadSection = ({ userData, isAvatarChangeAllowed }: HeadSectionProps) => {
  const [isAddAvatarVisible, setIsAddAvatarVisible] = useState(false);
  const src = userData.avatar ? `${BASE_URL}${USER_AVATAR_FOLDER}/${userData.avatar}` : undefined;

  return (
    <>
      <Col>
        <Space align="center" style={{ marginLeft: 10 }}>
          <Avatar key={src} src={src} />

          <Title level={3} style={{ margin: 0, paddingBottom: '4px' }}>
            {userData.login}
          </Title>
        </Space>
      </Col>
      <Col>
        {isAvatarChangeAllowed && (
          <Button
            id="me-add-avatar-modal-open-button"
            icon={<CameraOutlined />}
            onClick={() => setIsAddAvatarVisible(true)}
          />
        )}
      </Col>

      <UploadAvatarModal
        userId={userData.id}
        isModalVisible={isAddAvatarVisible}
        setIsModalVisible={setIsAddAvatarVisible}
      />
    </>
  );
};

export default HeadSection;
